import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import { useEffect, useState } from 'react';
import AddBiometricDevice from './AddBiometricDevice';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IDeleteResponse, IDevice, IPageInfo } from '@/interfaces/common.model';
import { IAddDeviceForm } from '@/interfaces/biometricDevice.model';
import FilterComponent from '@/components/common/FilterComponent';
import useFilter from '@/hooks/useFilter';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { getFilterUrl, showToastNotification } from '@/utility/helper';

interface IpageStates extends IPageInfo {
  count: number;
  tableLoader: boolean;
  deviceList: IAddDeviceForm[];
  searchQuery: string;
}
interface IBiometricDeviceResponse extends IDeleteResponse {
  data: { device: IDevice[] };
}
const BiometricDevices = () => {
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  // const [editData, setEditData] = useState<IAddDeviceForm | null>(null);
  const [pageStates, setPageStates] = useState<IpageStates>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    deviceList: [],
    searchQuery: '',
  });
  const tableHeading: ITableColumn<IAddDeviceForm>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Device Name' },
    { value: 'ip', label: 'IP' },
    { value: 'office', label: 'Office' },
  ];
  const [modal, setModal] = useState<boolean>(false);
  // const actionData: IActionData<IAddDeviceForm>[] = [
  // {
  //   label: 'View',
  //   className: 'btn btn-link ',
  //   icon: <ViewIcon />,
  //   title: 'view',
  //   clickHandler: (data: ITableData) =>
  //     navigate(RoutesLink?.companyDetail + `/${data?.id}`),
  // },
  //   {
  //     label: 'Edit',
  //     className: 'btn btn-link ',
  //     icon: <EditIcon />,
  //     title: 'edit',
  //     clickHandler: (data: IAddDeviceForm) => {
  //       setEditData(data);
  //       setModal(!modal);
  //     },
  //   },
  // ];
  useEffect(() => {
    getDevices();
  }, [pageStates.currentPage, filterDetails?.pageSize, pageStates.searchQuery]);
  const getDevices = async () => {
    setPageStates((prev) => ({ ...prev, tableLoader: true }));
    try {
      const filter = {
        search: pageStates.searchQuery,
        pageSize: filterDetails?.pageSize,
        pageNumber: filterDetails.currentPage,
      };
      const response: IBiometricDeviceResponse = await callApi(
        API_URL + API_ENDPOINT.getDevice + `?${getFilterUrl(filter)}`,
        {
          method: 'GET',
        },
      );
      if (response?.status) {
        const newData: IAddDeviceForm[] = response?.data?.device?.map(
          (device, index) => {
            return {
              ...device,
              index: index,
              name: device?.name,
              ip: device?.address,
              office: device?.site?.name,
              officeId: device?.siteId,
            };
          },
        );
        setPageStates((prev) => ({
          ...prev,
          deviceList: newData,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({ ...prev, tableLoader: false }));
    }
  };
  const { pageChangeHandler, handleSearchChange, handleChangePageSize } =
    useFilter(pageStates, setPageStates);
  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Biometric Device'}
            buttonIcon={<PlusIcon />}
            buttonText="Add Devices"
            clickHandler={() => setModal(!modal)}
          />
          <CardLayout isGrid={tableView === 'grid'}>
            <FilterComponent handleSearch={handleSearchChange} isGrid={false} />
            <CommonTable
              tableData={pageStates?.deviceList}
              tableHeading={tableHeading}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              pageSize={filterDetails?.pageSize}
              currentPage={pageStates?.currentPage}
              // ActionData={actionData}
              handleChangePageSize={handleChangePageSize}
              pageChangeHandler={pageChangeHandler}
            />
          </CardLayout>
        </div>
      </Layout>
      <AddBiometricDevice
        editData={null}
        isOpen={modal}
        getDevices={getDevices}
        onClose={() => setModal(!modal)}
      />
    </>
  );
};

export default BiometricDevices;
